export const PROBLEM_BASE_URL = 'https://www.jhipster.tech/problem';
export const EMAIL_ALREADY_USED_TYPE = `${PROBLEM_BASE_URL}/email-already-used`;
export const LOGIN_ALREADY_USED_TYPE = `${PROBLEM_BASE_URL}/login-already-used`;
export const CLAVE_MORAL = '1';
export const CLAVE_FISICA = '2';
export const CLAVE_SECTOR_PRIVADA = '1';
export const CLAVE_SECTOR_PUBLICA = '2';
export const CLAVE_SECTOR_SOCIAL = '3';
export const CLAVE_TIPO_INST_EMPRESA = '6';
export const CLAVE_TIPO_INST_EDUCACION = '7';
export const CLAVE_NIVEL_FEDERAL = '1';
export const CLAVE_NIVEL_ESTATAL = '2';
export const CLAVE_NIVEL_MUNICIPAL = '3';
export const CLAVE_TIPO_INST_ENTIDAD_EDUCACION = '4';
export const CLAVE_TIPO_INST_ENTIDAD_SEC_PUBLICO = '5';
export const CLAVE_TIPO_INST_ENTIDAD_CONACYT = '1';
export const FECHA_ACTUAL = new Date();
export const RFC_PERSONA_MORAL_REGEX = /^([A-ZÑ&]{3})(\d{2})(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([A-Z\d]{3})$/;
export const RFC_PERSONA_FISICA_REGEX = /^([A-ZÑ&]{4})(\d{2})(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([A-Z\d]{3})$/;
export const PODER_NOTARIAL = '5';
export const CARRETERA = 'CARRETERA';
export const CAMINO = 'CAMINO';
export const DOMICILIO_FISCAL_ID = '3';
export const DOMICILIO_RESIDENCIA_ID = '1';
export const DOMICILIO_FISCAL_NAME = 'Domicilio Fiscal';
export const DOMICILIO_RESIDENCIA_NAME = 'Domicilio de Residencia';
export const TIPO_UBICACION = 'NACIONAL';
export const RURAL = 'RURAL';
export const URBANO = 'URBANO';
export const MUNICIPIO = 'municipio';
export const LOCALIDAD = 'localidad';
export const ESTADO_CAPTURA = 'CAP';
export const ESTADO_EN_REVISION = 'EN_REV';
export const ESTATUS_COMPLETA = 'Completa';
export const ESTATUS_INCOMPLETA = 'Incompleta';
export const CLAVE_VIALIDAD_CARRETERA = '01';
export const MAX_FILE_SIZE = 10;
export const ESTATUS_REVISADO_CON_OBS = 'R_CON_OBS';
export const ESTATUS_REVISADO_SIN_OBS = 'R_SIN_OBS';
export const ESTATUS_EN_REV = 2;
export const PER_MORAL = '1';
export const PER_FISICA = '2';
export const COMMENT_LENGTH = 20;
export const ESTATUS_CAPTURA_NOMBRE = 'Captura';
export const ESTATUS_CAPTURA = 1;
export const ESTADO_ELIMINADO = 'ELIMINADO';
export const ROLE_EXTERNAL_USER = 'ROLE_EXTERNAL_USER';
export const ROLE_OPERATIVO_RENIECYT = 'ROLE_OPERATIVO_RENIECYT';
export const ROLE_CONSULTA_USER = 'ROLE_OPERATIVO_CONSULTA_RENIECYT';
export const ROLE_DIRECCION_RENIECYT = 'ROLE_DIRECCION_RENIECYT';
export const ROLE_CONSULTA = 'ROLE_CONSULTA';
export const ROLE_REGISTRO_ANOTACIONES = 'ROLE_REGISTRO_ANOTACIONES';
export const ESTATUS_BAJA = 'BAJA';
export const MAXIMO_REGISTROS_PAGINACION_SACI = 300;
